import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import resources from './translation.json';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    resources,
    interpolation: {
      escapeValue: false, // Disables HTML character escape
    },
    react: {
      defaultTransParent: 'div',
    },
  })
  // eslint-disable-next-line no-console
  .catch(console.error);

export default i18n;
